import script from "./OcrVerificationProductsTableRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./OcrVerificationProductsTableRow.vue?vue&type=script&setup=true&lang=ts"

import "./OcrVerificationProductsTableRow.vue?vue&type=style&index=0&id=b10edfe4&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b10edfe4"]])

export default __exports__